<template>
  <div>
    <component ref="row-template" :is="custom" :isShowSelect="isShowSelect" :props="props" @editToggle="editToggle"
      @moveRow="moveRow" @editRow="editRow" @deleteRow="deleteRow" @closeRow="closeRow" />
  </div>
</template>

<script>
import rowDefault from './row-custom/row-default.vue';
import rowMailQueue from './row-custom/row-mail-queue.vue';
import rowRuleSetting from './row-custom/row-rule-setting.vue';
import rowQueueManagement from './row-custom/row-queue-management.vue';
import rowQueueReport from './row-custom/row-queue-report.vue';
export default {
  components: {
    rowDefault,
    rowMailQueue,
    rowRuleSetting,
    rowQueueManagement,
    rowQueueReport
  },

  props: {
    props: Object,
    custom: String,
    isShowSelect: Boolean,
  },
  data() {
    return {
      indicator: null,
    };
  },
  computed: {},

  methods: {
    editToggle(v) {
      this.$emit('editToggle', v);
    },
    moveRow(v) {
      this.$emit('moveRow', v);
    },
    editRow(v) {
      this.$emit('editRow', v);
    },
    deleteRow(v) {
      this.$emit('deleteRow', v);
    },
    closeRow(v) {
      this.$emit('closeRow', v);
    },
  },
};
</script>
